import { Injectable } from '@angular/core';

const MAX_RECENT_DIAGNOSTICS = 80;

@Injectable({ providedIn: 'root' })
export class FrontendDiagnosticsService {
  private entries: string[] = [];

  addError(message: string, stack?: string): void {
    const stamp = new Date().toISOString();
    const entry = stack
      ? `[${stamp}] ERROR: ${message}\n${stack}`
      : `[${stamp}] ERROR: ${message}`;
    this.push(entry);
  }

  addDiagnostic(message: string, context?: string): void {
    const stamp = new Date().toISOString();
    const entry = context
      ? `[${stamp}] TRACE: ${message} | ${context}`
      : `[${stamp}] TRACE: ${message}`;
    this.push(entry);
  }

  getRecentEntries(): string[] {
    return [...this.entries];
  }

  private push(entry: string): void {
    this.entries.push(entry);
    if (this.entries.length > MAX_RECENT_DIAGNOSTICS) {
      this.entries.shift();
    }
  }
}
